/**
 * 회원가입 디버그(소셜+이메일·비번, 본인인증 생략, 폼 자동 채움).
 * `npm start` 등으로 뜨는 development에서만 켠다.
 */
export function isRegisterDebugFeaturesEnabled(): boolean {
  return process.env.NODE_ENV === 'development'
}

/** 소셜 회원가입 시에도 이메일·비밀번호 입력·전송 허용 */
export function isRegisterDebugEmailWithSocial(): boolean {
  return isRegisterDebugFeaturesEnabled()
}

/** 부트페이 본인인증 없이 입력한 휴대폰 번호로만 가입 */
export function isRegisterDebugSkipPhoneVerification(): boolean {
  return isRegisterDebugFeaturesEnabled()
}
